import styled from "styled-components";

export const ContactLeft = styled.div`
  display: grid;
  flex-direction: column;
  align-items: start;
  gap: 20px;
  padding: 10px;
  color: #0467fb;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const ContactLeftTitle = styled.div`
  font-weight: 600;
  color: #0467fb;
  font-size: 30px;
  margin-bottom: 5px;
  display: inline;
  @media (max-width: 1400px) {
    font-size: 30px;
  }
`;

export const ContactInputs = styled.input`
  width: 350px;
  height: 50px;
  border: none;
  padding-left: 25px;
  font-weight: 500;
  color: #0467fb;
  border-radius: 5px;
  margin-top: 20px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  -webkit-filter: drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017));
  filter: drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017));
  &:focus {
    border: #0467fb;
  }
  &::placeholder {
    color: #0467fb;
  }
  @media (max-width: 1400px) {
    display: flex;
    width: 100%;
    margin-bottom: 10px;
    color: #0467fb;
  }
`;

export const ContactTextArea = styled.textarea`
  width: 350px;
  height: 200px;
  padding-top: 15px;
  border-radius: 5px;
  margin-top: 20px;
  border: none;
  padding-left: 25px;
  font-weight: 500;
  color: #0467fb;
  border-radius: 5px;
  margin-top: 20px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  -webkit-filter: drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017));
  filter: drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017));
  &::placeholder {
    color: #0467fb;
  }
  @media (max-width: 1400px) {
    display: flex;
    margin-bottom: 10px;
    color: #0467fb;
  }
`;

export const ContactFormButton = styled.button`
  display: grid;
  align-items: center;
  padding: 15px 30px;
  font-size: 16px;
  gap: 10px;
  border: none;
  border-radius: 5px;
  background-color: transparent;
  color: #0467fb;
  padding: 8px 20px;
  border: 1px solid var(--primary);
  transition: all 0.3s ease-out;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  -webkit-filter: drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017));
  filter: drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017));
  cursor: pointer;
  margin-top: 15px;
  &:hover {
    background-color: #848684;
    color: #0467fb;
    transition: all 0.3s ease-out;
  }
  @media (max-width: 1400px) {
    font-size: 12px;
  }
`;
